@if (editMode) {
  <div></div>
}

@if (!editMode) {
  <div>
    <div class="message-bubble">
      <div class="message-text">
        {{ confirmationText }}
        @for (confirmationButton of confirmationButtons; track confirmationButton.uId; let i = $index) {
          <div>
            {{ 'COMMUNICATIONS.MESSAGE-REPLY' | translate }} {{ (i +1) + ':' }} {{ confirmationButton.text }}
          </div>
        }
      </div>
    </div>
  </div>
}